import { useMutation } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { apiClient } from 'src/services/api/client';
import type { ILeadRoutingRule } from 'src/services/api/lead-routing-rules/types';
import { LEAD_ROUTING_RULES_PATH } from 'src/services/api/lead-routing-rules/path';

type IUpdateLeadRoutingRulesOrderResponse = {
    msg: string;
    rule: ILeadRoutingRule;
}

type IUpdateLeadRoutingRulesOrderRequest = {
    order: number[];
}

export const useUpdateLeadRoutingRulesOrder = () => {
    const { addNotification } = useNotifications();

    return useMutation<
        IUpdateLeadRoutingRulesOrderResponse,
        IStandardErrorResponse,
        IUpdateLeadRoutingRulesOrderRequest
    >(
        (payload) => {
            return apiClient(`${LEAD_ROUTING_RULES_PATH}/order`, {
                method: 'patch',
                json: payload,
            }).json<IUpdateLeadRoutingRulesOrderResponse>();
        }, {
            onSuccess: () => {
                addNotification('Lead routing rules order updated successfully', 'success');
            }, onError: (error) => {
                const errorMessage = error.msg || 'Failed to update lead routing rules order';
                addNotification(errorMessage, 'error');
            }
        });
};
